import BookBorrowDataTable from '../../../features/book-management/book-borrow/BookBorrowDataTable'
import BookFilterHeader from '../../../features/book-management/book-list/BookFilterHeader'
import { PATH } from '../../../data/router_path'
import { useEffect } from 'react'
export default function BookBorrow() {
  const path = PATH.BOOK.BORROW
  useEffect(() => {
    localStorage.setItem('isBorrow', true)
    return () => {
      localStorage.removeItem('isBorrow')
    }
  }, [])
  useEffect(() => {
    const handleClearData = () => {
      localStorage.removeItem('isBorrow')
    }
    window.addEventListener('beforeunload', handleClearData)
    return () => {
      window.removeEventListener('beforeunload', handleClearData)
    }
  })
  return (
    <div className="flex flex-col">
      <BookFilterHeader title={'Thông tin mượn trả'} path={path} />
      <BookBorrowDataTable path={path} />
    </div>
  )
}
